import moment from "moment";
import telematicsService from "../../api/telematics.service";

export default {
  name: "maintenance",
  components: {},
  props: ["respData"],
  data() {
    return {
      search: "",

      isMaintenanceLoading: false,

      maintenanceList: [],

      responseData: {},
      maintenanceListHeader: [
        { text: "#", value: "sno" },
        { text: "Work Order#", value: "workOrder" },
        { text: "Template Name", value: "templateName", width: "200px" },
        { text: "Customer", value: "customer" },
        { text: "Status", value: "status" },
        { text: "Trigger", value: "triggerValue" },
        { text: "Service Hours", value: "serviceHours" },
        { text: "Service Miles", value: "serviceMiles" },
        { text: "Category", value: "category" },
        { text: "Stock Key", value: "stockKey" },
        { text: "Notes", value: "notes" },
      ],

      expanded: [],
      workOrderSubHeaders: [
        { text: "Id", value: "id" },
        { text: "Model", value: "modelType" },
        { text: "Name", value: "name" },
        { text: "Quantity", value: "quantity" },
      ],
      workOrderHeaders: [
        { text: "Id", value: "id" },
        { text: "Open Date", value: "openDateTime" },
        { text: "Close Date", value: "closeDateTime" },
        { text: "Status", value: "status" },
        { text: "Type", value: "type" },
      ],
      workOrdersList: [],
      workOrderSearch: "",
      isWorkOrderInfo: false,
      workOrderObj: {},
      dialogHeaders: [
        { text: "#", value: "sno" },
        { text: "Notes", value: "value" },
      ],
      workOrderDetails: [],
      workOrderDialog: false,
    };
  },
  filters: {
    formatDatesUS: function (value) {
      if (value) {
        const format = "MM/DD/YYYY";
        return moment(value).format(format);
      }
    },
    numberFormat: function (value) {
      if (value != "Quarterly" || value != "Monthly" || value != "yearly") {
        return Number(value).toLocaleString();
      }
    },
  },
  mounted() {
    this.responseData = this.respData;
    this.getMaintenanceList();
    let workOrdersList = this.responseData.workOrders
      ? this.responseData.workOrders
      : [];
    this.workOrdersList = workOrdersList.map((d, index) => ({
      ...d,
      sno: index + 1,
    }));
  },
  methods: {
    clickRow(item, event) {
      if (event.isExpanded) {
        const index = this.expanded.findIndex((i) => i === item);
        this.expanded.splice(index, 1);
      } else {
        this.expanded.push(item);
      }
    },
    expandAll() {
      this.$data.expanded = this.$data.workOrdersList;
    },
    collapseAll() {
      this.$data.expanded = [];
    },
    async getMaintenanceList() {
      try {
        this.isMaintenanceLoading = true;
        let assetId = this.$route.params.assetId;
        let response = await telematicsService.getMaintenanceListNew(assetId);
        if (response) {
          this.maintenanceList = response.data.map((d, index) => ({
            ...d,
            sno: index + 1,
          }));
          this.isMaintenanceLoading = false;
        }
      } catch (error) {
        this.isMaintenanceLoading = true;
      }
    },
    async openWorkOrderDialog(item) {
      this.workOrderDialog = true;
      this.workOrderObj = {};
      this.workOrderDetails = [];
      this.isWorkOrderInfo = true;
      try {
        let response = await telematicsService.getWorkOrderIdData(
          item.workOrder
        );
        if (response.isSuccess) {
          this.workOrderObj = response.data;
          this.workOrderDetails = response.data.notes.map((d, index) => ({
            ...d,
            sno: index + 1,
          }));
          this.isWorkOrderInfo = false;
        } else {
          this.workOrderObj = {};
          this.workOrderDetails = [];
          this.isWorkOrderInfo = false;
        }
      } catch (err) {
        this.isWorkOrderInfo = false;
        console.log(err);
      }
    },
    closeDialog() {
      this.workOrderDialog = false;
      this.workOrderObj = {};
    },
  },
};
